<div id="pdp_benefits" class="benefits_container">
  <ul class="list-unstyled">
    @if (klarnaPayments) {
      <li class="benefits_item klarna-benefits">
        <app-popover
          #popOverParentKlarnaQuotasChild
          class="size"
          [popOverTarget]="popOverParentKlarnaQuotas"
          [placement]="'top'"
          [mockParentSize]="true"
        >
          <p i18n="@@product.benefits.klarnaQuotas">
            *The price of the instalments is calculated on the basis of the final price of the product.
          </p>
          @if (locale === 'fr-FR') {
            <p i18n="@@product.benefits.klarnaQuotas2">
              L'utilisation de Klarna peut augmenter d'un jour les délais de livraison.
            </p>
          }
        </app-popover>
        <div
          #popOverParentKlarnaQuotas
          class="benefits_content benefits_link"
          role="button"
          tabindex="0"
          (click)="popOverParentKlarnaQuotasChild.openPopover()"
          (keypress)="popOverParentKlarnaQuotasChild.openPopover()"
        >
          <div id="klarna" class="benefits_image">
            <picture>
              <img alt="Klarna" [src]="'assets/images/payment-methods/klarna.png' | staticFileHash" />
            </picture>
          </div>
          <div class="benefits_text">
            <p i18n="@@product.benefits.klarna">
              Pay in {{ klarnaInstallments }} installments of {{ klarnaStringPayments }} each.
            </p>
          </div>
        </div>
      </li>
    }
    <li class="benefits_item advantage-free-shipping">
      <app-popover #popoverKlarnaParentChild [popOverTarget]="popoverKlarnaParent" [placement]="'top'" [mockParentSize]="true">
        <p class="mb-3">
          <strong i18n="@@product.benefits.freeShippingPopoverTitle"
            >Free delivery on orders over {{ freeShippingValueString }}!</strong
          >
        </p>
        @if (locale === 'es-ES') {
          <p>Entrega estándar para España excepto Baleares. <strong>9,90 €</strong></p>
          <p>Entrega estándar para Baleares. <strong>13,90 €</strong></p>
        }
        @if (locale === 'fr-FR') {
          <p>Entrée standard pour la France. <strong>8,99 €</strong></p>
        }
        <a
          href="docs/cgv"
          title="Delivery information"
          i18n-title="@@DELIVERY_INFO"
          target="_blank"
          onclick=""
          i18n="@@CLICK_HERE"
          >Click here</a
        >
      </app-popover>
      <div
        #popoverKlarnaParent
        class="benefits_content benefits_link"
        role="button"
        tabindex="0"
        (click)="popoverKlarnaParentChild.openPopover()"
        (keypress)="popoverKlarnaParentChild.openPopover()"
      >
        <div class="benefits_image">
          <picture>
            <img
              src="https://cdn-prod.scalefast.com/public/assets/img/resized/oralb-store/gno3grQvrocket_40_KR.png"
              alt="Icona dei benefici"
            />
          </picture>
        </div>
        <div class="benefits_text">
          @if (productPrice && productPrice >= freeShippingValue) {
            <p i18n="@@product.benefits.freeShipping">By ordering this product, delivery will be <strong>FREE</strong></p>
          }
          @if (productPrice && productPrice < freeShippingValue) {
            <p i18n="@@product.benefits.noFreeShipping">
              Only {{ freeShippingAmountLeftString }} left to get <strong>free shipping</strong>
            </p>
          }
        </div>
      </div>
    </li>
    @if (!isPohProduct) {
      <li class="benefits_item advantage-newsletter">
        <a href="#" (click)="clickOpenNewsletterModal($event)" (keypress)="clickOpenNewsletterModal($event)">
          <div class="benefits_content">
            <div class="benefits_image">
              <picture>
                <img
                  src="https://cdn-prod.scalefast.com/public/assets/img/resized/oralb-store/gvwlpR1Fperson_40_KR.png"
                  alt="Icona dei benefici"
                />
              </picture>
            </div>
            <div class="benefits_text">
              <p i18n="@@product.benefits.newsletter">Sign up for the newsletter for 10% discount.</p>
            </div>
          </div>
        </a>
      </li>
    }
    <li class="benefits_item">
      <app-popover #returnContentParentChild [popOverTarget]="returnContentParent" [placement]="'top'" [mockParentSize]="true">
        <p class="mb-3">
          <strong i18n="@@product.benefits.return">30 days to get your money back</strong>
        </p>
        @if (locale === 'es-ES') {
          <p>(programa válido para compras de cepillos de dientes eléctricos y irrigadores dentales)</p>
          <p>
            Siempre le damos la oportunidad de probar nuestros cepillos de dientes eléctricos y irrigadores dentales. Si no está
            100% satisfecho con el producto, puede devolverlo dentro de los 30 días siguientes a la fecha de compra. Si quiere,
            puede hacer una devolución.
          </p>
          <a href="30-dias-de-prueba-gratis" title="Delivery information" target="_blank" onclick="" i18n="@@CLICK_HERE"
            >Click here</a
          >
        }
        @if (locale === 'fr-FR') {
          <p>(programme valide pour l'achat de brosses à dents électriques et d'hydropulseurs)</p>
          <p>
            Nous vous donnons toujours la possibilité d'essayer nos brosses à dents électriques et nos hydropulseurs. Si vous
            n'êtes pas satisfait à 100 % du produit, vous pouvez le retourner dans les 30 jours suivant la date d'achat. Si vous
            souhaitez faire un retour.
          </p>
          <a
            href="https://www.satisfaitourembourse-oralb.fr/"
            title="Delivery information"
            target="_blank"
            onclick=""
            i18n="@@CLICK_HERE"
            >Click here</a
          >
        }
      </app-popover>
      <div
        #returnContentParent
        class="benefits_content benefits_link"
        role="button"
        tabindex="0"
        (click)="returnContentParentChild.openPopover()"
        (keypress)="returnContentParentChild.openPopover()"
      >
        <div class="benefits_image">
          <picture>
            <img
              src="https://cdn-prod.scalefast.com/public/assets/img/resized/oralb-store/FsEJsZujlabel_40_KR.png"
              alt="Icona dei benefici"
            />
          </picture>
        </div>
        <div class="benefits_text">
          <p i18n="@@product.benefits.return">30 days to get your money back.</p>
        </div>
      </div>
    </li>
    @if (locale === 'fr-FR') {
      <li class="benefits_item">
        <a [href]="accountSectionURL('warranty-extension')">
          <div class="benefits_content link-benefit">
            <div class="benefits_image">
              <picture>
                <img
                  src="https://cdn-prod.scalefast.com/public/assets/img/resized/oralb-store/F4BFwbOVcube_40_KR.png"
                  alt="Icona dei benefici"
                />
              </picture>
            </div>
            <div class="benefits_text">
              <p i18n="@@product.benefits.warranty">1 year free extended warranty.</p>
            </div>
          </div>
        </a>
      </li>
    }
    @if (locale === 'es-ES') {
      <li class="benefits_item klarna-benefits">
        <app-popover
          #klarnaContentPopoverParentChild
          [popOverTarget]="klarnaContentPopoverParent"
          [placement]="'top'"
          [mockParentSize]="true"
        >
          <p>La utilización de Klarna puede añadir un día de retraso en la entrega.</p>
          <p class="mb-3">
            <strong>Pago a plazos con Klarna</strong>
          </p>
          <p>
            Klarna es nuestro socio de confianza. Ofrece opciones de pago seguras y convenientes al comprar productos Oral-B.
            Podrá utilizar la tarjeta de crédito que use habitualmente en sus compras online para pagar poco a poco, en pequeñas
            cuotas.
          </p>
          <p>
            Puede optar por adquirir un producto pagando en 3 cómodos plazos en los pedidos con un valor igual o superior a 105€.
            Puede optar por utilizar Klarna siempre que utilice su tarjeta de crédito; la transacción se aprobará en función de
            sus líneas de crédito disponibles. Puede consultar nuestros términos de servicio para obtener más detalles.
          </p>
          <a href="https://www.oralb.es/docs/cgv#/klarna" target="_blank" onclick="" i18n="@@CLICK_HERE">Click here</a>
        </app-popover>
        <div
          #klarnaContentPopoverParent
          class="benefits_content benefits_link"
          role="button"
          tabindex="0"
          (click)="klarnaContentPopoverParentChild.openPopover()"
          (keypress)="klarnaContentPopoverParentChild.openPopover()"
        >
          <div id="klarna" class="benefits_image">
            <picture>
              <img alt="Klarna" [src]="'assets/images/payment-methods/klarna.png' | staticFileHash" />
            </picture>
          </div>
          <div class="benefits_text">
            <p>Pago a plazos con Klarna</p>
          </div>
        </div>
      </li>
    }
  </ul>
</div>
